import { useTranslation } from 'react-i18next';

export default function HomeSeeAllCard({ onClick, height = 160 }) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        'relative flex h-40 w-20 flex-shrink-0 items-center justify-center',
        'overflow-hidden rounded-home-24 bg-surface-2 text-text-primary',
        'border border-white/8 p-0 text-center',
      ].join(' ')}
      style={{ height }}
      aria-label={t('common.seeAll', 'See all')}
      data-testid="home-section-see-all-card"
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.12),rgba(255,255,255,0.02)_58%,rgba(255,255,255,0))]"
      />
      <span className="relative z-[1] font-sans text-[20px] font-semibold leading-none">
        All
      </span>
    </button>
  );
}
